/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleDashboardAnalyticsState.js'
import mutations from './moduleDashboardAnalyticsMutations.js'
import actions from './moduleDashboardAnalyticsActions.js'
import getters from './moduleDashboardAnalyticsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
 